



















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import {
  MedicalSpecification,
  DetailModel
} from "@/components/medicalTransmissionEdit/types";
import { PulldownItem, SelectItemString } from "@/types";

@Component
export default class OtherMedical1 extends Vue {
  @Prop() tab!: MedicalSpecification;
  @Prop() medical_examination_classification_codes!: PulldownItem[]; //受診等区分コード
}
